<template>
    <div class="row">
        <div class="button-group">
            <square-button v-for="(button, index) in buttons" :key="index" @click="handleClick(button.label)"
                :icon="button.icon" :isDisabled="button.disabled" :isHidden="button.hidden">
                {{ button.label }}
            </square-button>
        </div>
    </div>
    <hr />
    <div class="row">
        <div v-if="variableButtons.length > 0" class="button-group-variable">
            <div v-for="(button, index) in variableButtons" :key="index">
                <variable-field-button @click="handleVariableClick(button.field_value)">
                    {{ button.label }}
                </variable-field-button>
                <hr>
            </div>
        </div>
        
        <div v-if="showConditionsInfo" class="col-12 mt-3 p-3" style="background-color: #eaf8fc; border-left: 4px solid #00a0c1; border-radius: 4px; font-size: 0.9em; color: #435666;">
            <strong>Condition Instructions:</strong><br/>
            Evaluate lead data dynamically to show or hide content between the Opening and Closing conditional tags.<br/>
            <br/>
            <strong>Usage Example:</strong><br/>
            <code v-pre>{{#if_equals target_variable="lead_status" value="Qualified"}}</code><br/>
            <i>...Content to show if lead status is Qualified...</i><br/>
            <code v-pre>{{/if_equals}}</code><br/>
            <br/>
            • <strong>AND logic (Multiple Conditions):</strong> Nest one IF statement inside another IF statement.<br/>
            • <strong>OR logic (Multiple Values):</strong> Separate target values with a comma (e.g. <code>value="NSW,VIC,QLD"</code>). <em>Do not add spaces after the commas.</em>
        </div>
    </div>

    <div class="row" v-if="this.showTestimonial">
        <testimonial-variable-field></testimonial-variable-field>
    </div>

    <div class="row" v-if="this.showImageGridSettings">
        <ImageGridVariableField></ImageGridVariableField>
    </div>
</template>

<script>
import 'vue-tel-input/dist/vue-tel-input.css'
import 'vue-multiselect/dist/vue-multiselect.css'
import "@/assets/scss/vue-multiselect.scss";
import SquareButton from '@/components/Utilities/square-button.vue';
import VariableFieldButton from '@/components/Utilities/variable-field-button.vue';
import TestimonialVariableField from '@/components/ContentLibrary/TestimonialVariableFields.vue';
import ImageGridVariableField from '@/components/ContentLibrary/ImageGridVariableFields.vue';

//const _ = require('lodash');

export default {

    components: {
        SquareButton,
        VariableFieldButton,
        TestimonialVariableField,
        ImageGridVariableField
    },

    emits: ['onSubmit', 'onDelete'],

    props: {
        item: {
            type: Object,
            // required: true,
        },

        isHidden: {
            type: Boolean,
        },
    },

    data() {
        return {
            organisationVariableFields: [],
            contractVariableFields: [],
            proposalVariableFields:[],
            conditionVariableFields: [],
            organisations: [],
            rolesVariableFields: [],
            productVariableFields: [],
            userVariableFields: [],
            buttons: [
                //{ label: 'Block Details', icon: 'fa-solid fa-circle-info', disabled: false, hidden: false },
                { label: 'Organisations', icon: 'fa-solid fa-users', disabled: false, hidden: false },
                { label: 'Proposal', icon: 'fa-solid fa-handshake', disabled: false, hidden: false },
                { label: 'Contract', icon: 'fa-solid fa-file-contract', disabled: false, hidden: false },
                { label: 'Conditions', icon: 'fa-solid fa-code', disabled: false, hidden: false },
                { label: 'Testimonials', icon: 'fa-solid fa-message', disabled: false, hidden: true },
                { label: 'Image Grid', icon: 'fa-solid fa-images', disabled: false, hidden: true },
                { label: 'Roles', icon: 'fa-solid fa-briefcase', disabled: false, hidden: true },
                { label: 'Products', icon: 'fa-solid fa-box-open', disabled: false, hidden: true },
                { label: 'Image Settings', icon: 'fa-solid fa-cog', disabled: false, hidden: true },
                { label: 'Users', icon: 'fa-solid fa-user', disabled: false, hidden: true },
                { label: 'Jobs', icon: 'fa-solid fa-suitcase', disabled: true, hidden: true },
                { label: 'Clients', icon: 'fa-solid fa-handshake', disabled: true, hidden: true },
                { label: 'Leads', icon: 'fa-solid fa-chart-line', disabled: true, hidden: true },
            ],
            variableButtons: [

            ],
            showTestimonial: false,
            showImageGridSettings: false,
            showConditionsInfo: false,
        }
    },

    computed: {

    },

    watch: {

    },

    created() {
        this.init()
    },

    mounted() {

    },

    methods: {
        init() {
            //this.getRolesVariableFields()
            this.getOrganisationVariableFields()
            this.getContractVariableFields()
            this.getProposalVariableFields()
            this.getConditionVariableFields()
            //this.getProductVariableFields()
            //this.getUserVariableFields()
            this.getAuthOrganisations()
        },

        handleClick(clickLabel) {
            if (clickLabel == "Organisations") {
                this.variableButtons = []
                if (this.organisationVariableFields.length > 0)
                    this.organisationVariableFields.forEach((vfield) => {
                        this.variableButtons.push(
                            {
                                label: vfield.display_name,
                                field_value: vfield.name
                            }
                        )
                    })
            } else if (clickLabel == "Contract") {
                 this.variableButtons = []
                if (this.contractVariableFields.length > 0)
                    this.contractVariableFields.forEach((vfield) => {
                        this.variableButtons.push(
                            {
                                label: vfield.display_name,
                                field_value: vfield.name
                            }
                        )
                    })
            } else if (clickLabel == "Proposal") {
                 this.variableButtons = []
                if (this.proposalVariableFields.length > 0)
                    this.proposalVariableFields.forEach((vfield) => {
                        this.variableButtons.push(
                            {
                                label: vfield.display_name,
                                field_value: vfield.name
                            }
                        )
                    })
            } else if (clickLabel == "Conditions") {
                 this.variableButtons = []
                if (this.conditionVariableFields.length > 0)
                    this.conditionVariableFields.forEach((vfield) => {
                        this.variableButtons.push(
                            {
                                label: vfield.display_name,
                                field_value: vfield.name
                            }
                        )
                    })
            }

            
            // else if (clickLabel == "Testimonials") {
            //     this.variableButtons = []
            //     this.showTestimonial = true
            //     this.showImageGridSettings = false
            //     return
            // } else if (clickLabel == "Image Grid") {
            //     this.variableButtons = []
            //     this.showImageGridSettings = true
            //     this.showTestimonial = false
            //     return
            // }

            this.showTestimonial = false
            this.showImageGridSettings = false
            this.showConditionsInfo = (clickLabel == "Conditions")
        },

        handleVariableClick(variable_value) {
            if (variable_value.includes("{{#if")) {
                this.$parent.addContent(`&nbsp;<mark><span id="variable_value_condition">` + variable_value + `</span></mark>&nbsp;`)
            } else {
                this.$parent.addContent(`&nbsp;<mark>{{<span style="color: red;">!*</span><span id="variable_value_${variable_value}">` + variable_value + `</span><span style="color: red;">*!</span>}}</mark>&nbsp;`)
            }
        },

        GetOrganisationName(org_id) {
            const organisation = this.organisations.find(org => org.id === org_id);
            return organisation ? organisation.name : null; // Or handle the case where no match is found
        },

        addTestimonialToContent(testimonial, b64img) {
            let hasb64Image = b64img != null && b64img != undefined
            let b64NoImage = `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACoCAMAAABt9SM9AAAAOVBMVEXU1NSampqXl5fX19fMzMyVlZXQ0NCgoKC/v7/ExMSkpKS6urqpqanT09OdnZ3Jycm0tLS1tbWtra0K+9GZAAAC+0lEQVR4nO3ci46iMBSAYeih3OSivv/DLqCFIiACGcl6/i+7yUQHM/wRaIszQQAAAAAAAAAAAAAAAAAAAAAAAAAAAAD8CAniA+TsH/+r5FKZMNz3r/mf1IpyydWGh5j67F34nuhgqzBM9Ly1LuZoLBOfvQ9f08Yqyr2n96iNFZ29D1/Txdp9IMVGUywh1udGsWSzoDsMH1/+Pj/WLd+uPcN3X9yj3881xIqTQ9dFY7Oz9+XP9bGkODyGKM/emb/Wxyq7t8du7cbp2Tvz1/pYUbu/6W7Nyctcfv2sNYplyp27K+1BrC3W7okLsd5vOCojhb7D8NNYUqa3i7+QRazlje62uQBab92PWIvy55DMpi4PsZY2uffDV+vGocRaEA9DfXN1U3BizW+RevOixD1IrPktbv4k0j1IrOUtnOp50iJWa2YlIfNiFZyzvKeLbFqg6lvZjFiD2s4EzNytRlMwzvKeTUJTTbfJbHck2oIR/MuTZnrvR+Jrcyjm3hFKrCDo3kDmNo3Qrjn4jxLLzWuGKeDyy6iPFbkxwvptVPWxJB/Gnu8ytM+pj+XNAU3+5hXSmlji3xLslxemL3CzkfZY5Xi+HJqlk/zdGPWx/FWrR63ZSXaZm5BY07v51XROLXH1vFbqjlVPPvkwHcnL45vUx5LqtdX0JC+pDYn1ssDXG4/km8tgSKzg+ZGamfeWP5K/++N7xbG8m12LJ/nho2/KY03P7q5L/ujRXAa94b3qWN6kcOYkL4FI/Xpwqo3lrnILtS6N0TeojhXMDBu8NM8PRRKrjSXXjZ/E1Rwr2thKc6ztH/HWHOvtGYtY41gJsZa4WEKsdY9YcRzXxFrXrS/YRkisVf7yMbFW9MtSxPqApEl7FBoXqzsmN1EUK+jWEWSY7mz/3V9FsR6O/qITsT6mMdaOY/Dpri5WmOwWqoolKwOEdVbRnzt6t5j80XBr/98d+f80s8QDrCnO3oGvkjI7QMEfDAEAAAAAAAAAAAAAAAAAAAAAAAAAAIAa/wDYuS0/E15ttAAAAABJRU5ErkJggg==`

            if(this.$parent.checkIfIDExist(`testimonial_hash_${testimonial.id}`)) {
                alert("Testimonial already exist")
                return
            }
        
            this.$parent.addTestimonialToGrid(testimonial,`
            <div class="testimonial-container" id="testimonial_hash_${testimonial.id}">
                 <button class="remove-testimonial-button">X</button>
                <div class="testimonial-avatar">
                    <img src="${(hasb64Image) ? b64img : b64NoImage}" alt="Testimonial Image">
                </div>
                <div class="testimonial-content">
                    <p class="testimonial-text">"${testimonial.testimonial}"</p>
                    <p class="testimonial-author">${testimonial.contact_name}</p>
                    <p class="testimonial-title">${testimonial.contact_role + "-" +
                this.GetOrganisationName(testimonial.organisation_id)}</p>
                </div>
            </div>`)
        },

        //added block type async function
        async getProductVariableFields() {
            await this.$axios.get("/categories?name=ProductVariableFields")
                .then((response) => {
                    this.productVariableFields = response.data.category.subcategories
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        //added block use async function
        async getRolesVariableFields() {
            await this.$axios.get("/categories?name=RolesVariableFields")
                .then((response) => {
                    this.rolesVariableFields = response.data.category.subcategories
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        //added block use async function
        async getOrganisationVariableFields() {
            await this.$axios.get("/categories?name=OrganisationVariableFields")
                .then((response) => {
                    this.organisationVariableFields = response.data.category.subcategories
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        async getContractVariableFields() {
            await this.$axios.get("/categories?name=ContractVariableFields")
                .then((response) => {
                    this.contractVariableFields = response.data.category.subcategories
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        async getProposalVariableFields() {
            await this.$axios.get("/categories?name=ProposalVariableFields")
                .then((response) => {
                    this.proposalVariableFields = response.data.category.subcategories
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        async getConditionVariableFields() {
            await this.$axios.get("/categories?name=ConditionVariableFields")
                .then((response) => {
                    this.conditionVariableFields = response.data.category.subcategories
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        //added block use async function
        async getUserVariableFields() {
            await this.$axios.get("/categories?name=UserVariableFields")
                .then((response) => {
                    this.userVariableFields = response.data.category.subcategories
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        async getAuthOrganisations() {
            await this.$axios_auth.get("/vertex/organisations")
                .then((response) => {
                    this.organisations = response.data.organisations
                })
                .catch((error) => {
                    this.$toast.error(error.response.data.message)
                })
        },

        removeTestimonial(id) {
      const testimonialElement = document.getElementById(`testimonial_hash_${id}`);
      if (testimonialElement) {
        // Remove the element from the DOM
        testimonialElement.remove();

        // If you are using TinyMCE, it generally observes DOM changes within its editable area.
        // However, if the editor doesn't automatically reflect the change,
        // you might need to explicitly notify TinyMCE.
        // For example, if you have access to the active TinyMCE editor instance:
        // const editor = tinymce.activeEditor;
        // if (editor) {
        //     editor.undoManager.add(); // To make the removal undoable
        //     editor.fire('change'); // To notify TinyMCE of content change
        // }
    }
}
    },
};

</script>

<style scoped>
/* form start */
form label:not(#isCharityLbl) {
    color: #00A0C1;
    margin: 0.5rem 0;
}

input:not([type="checkbox"]),
select {
    height: 40px;
    border-radius: 10px;
    max-width: 100px;
    border: 1px solid #D9D9D9;
    color: #435666;
}

.form--check-input {
    width: 12px;
    /* Increase width */
    height: 12px;
    /* Increase height */
    margin-left: -17px;
    margin-right: 10px;
}

/* form end */
.btn {
    width: 7rem;
}

.add-space {
    margin-bottom: 225px;
}

.button-group {
    display: grid;
    /* Use grid for layout */
    grid-template-columns: repeat(4, 1fr);
    /* 4 equal-width columns */
    grid-gap: 10px;
    /* Spacing between grid items */
}

.button-group-variable {
    display: grid;
    /* Use grid for easy layout */
    grid-template-columns: repeat(1, 1fr);
    /* 4 columns */
    grid-gap: 5px;
    /* Spacing between buttons */
    padding: 10px;
    overflow-y: auto;
    scrollbar-color: #00A0C1 lightblue;
    max-height: clamp(300px, calc(100vh - 300px), 900px);
    overflow-x: hidden;
}

.block-button-container {
    display: flex;
    margin-left: -3px;
    gap: 3px;
}

@media (min-width: 1900px) {

    /* Adjust breakpoint as needed */
    .block-button-container {
        gap: 6px;
        /* Larger gap for larger screens */
    }
}
</style>